'use strict';

var AppState = require('app_state');
var i18n = require('utils/i18n');
var CommonViews = require('components/common/views');
var Misc = require('utils/misc');

var DeviceFilterView = require('components/devices/views/common/device_filter_view');
var DeviceSelectView = require('components/devices/views/common/device_select_view');

var FilterView = Backbone.Marionette.LayoutView.extend({
    template: require('components/devices/templates/filter/filter'),
    regions: {
        deviceFilter: '#device-filter',
        deviceTable: '#device-table',
    },

    initialize: function (options) {
        var self = this;
        this.controller = options.controller;
        this.deviceFilterView = new DeviceFilterView({
            controller: this.controller,
            showResults: options.showResults,
            onFilterChanged: function (filter, isReload) {
                self.filterChanged(filter, isReload);
            },
            onLoadComplete: function () {
                self.showChildView('deviceFilter', self.deviceFilterView);
            },
            defaultFilter: options.defaultFilter,
        });
        this.overrideFilters = false;
    },

    filterChanged: function (filter, isReload) {
        var self = this;

        this.controller.setFilter(filter, this.overrideFilters);
        this.overrideFilters = true;
        if (!isReload) {
            // changing filter? -> reset the current page to 1
            AppState.setURLParameter({ page: 1 }, 'update');
            this.currentPage = 1;
        }
        this.controller.useDeviceList(function (data) {
            self.refreshDeviceSelect(filter, isReload);
        });
    },

    refreshDeviceSelect: function (filter, isReload) {
        var selectedList = undefined;
        if (this.deviceSelectView) selectedList = this.deviceSelectView.getSelectedList();

        var self = this;
        this.controller.useDeviceList(function (data) {
            if (self.options.onFilterChangeDone) {
                self.options.onFilterChangeDone(filter, isReload);
            }

            if (data === undefined || data.count == 0) {
                self.displayNoResults(data === undefined);
                return;
            }

            self.deviceSelectView = new DeviceSelectView({
                itemsPerPage: self.controller.getItemsPerPage(),
                controller: self.controller,
                collection: data.items,
                listResult: data.listResult,
                itemCount: data.count,
                currentPage: self.currentPage,
                isSummaryView: false,
                defaultSelectAll: false,
                selectedList: selectedList,
                hasRefreshButton: true,

                onRefresh: function () {
                    self.deviceFilterView.forceUpdate();
                },
                onUpdateGrouping: function () {
                    self.reloadFilter();
                },
            });
            self.showChildView('deviceTable', self.deviceSelectView);
        }, true);
    },

    displayNoResults: function (isError) {
        var text;
        var title;
        var colorClass;

        if (isError) {
            text = i18n.TR('Es konnten keine Geräte gefunden werden.');
            title = i18n.TR('Fehler beim Aktualisieren des Filters');
            colorClass = 'box-color-error';
        } else {
            text = '';
            title = i18n.TR('Keine Geräte gefunden');
        }

        var contentView = new CommonViews.Message({
            title: title,
            titleID: 'no-devices-found',
            text: text,
            color_class: colorClass,
        });
        this.showChildView('deviceTable', contentView);
    },

    reloadFilter: function () {
        var self = this;
        this.deviceFilterView = new DeviceFilterView({
            controller: this.controller,
            onFilterChanged: function (filter) {
                self.filterChanged(filter);
            },
            onLoadComplete: function () {
                self.showChildView('deviceFilter', self.deviceFilterView);
            },
            defaultFilter: this.controller.filter,
        });
    },
});

module.exports = FilterView;
